module.exports = __webpack_public_path__ + "static/media/rhodium2.f4a14e55.jpg";